import { render, staticRenderFns } from "./appendix-bg.vue?vue&type=template&id=4de54e48"
import script from "./appendix-bg.vue?vue&type=script&lang=js"
export * from "./appendix-bg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports